import type { ProjectSchemaJSON, PropertyTransform, ShapeJSON } from '@takeshape/schema';
import { getShapeById, transformOneOf } from '@takeshape/schema';
import { isRecord } from '@takeshape/util';
import isString from 'lodash/isString';
import omit from 'lodash/omit';

export function createTypenameToShapeId(projectSchema: ProjectSchemaJSON): PropertyTransform['process'] {
  return (obj, _schema, name, _shape, next) => {
    if (isRecord(obj)) {
      let shape: ShapeJSON | undefined;
      if (isString(obj._shapeId)) {
        shape = getShapeById(projectSchema, obj._shapeId);
      } else if (isString(obj.__typename)) {
        shape = projectSchema.shapes[obj.__typename];
      }

      if (shape) {
        const fixed = omit(obj, '__typename');
        fixed._shapeId = shape.id;
        return next(fixed, shape.schema, name);
      }

      throw new Error(
        `Unexpected Error: Unable to transform object with _shapeId or __typename "${obj._shapeId ?? obj.__typename}"`
      );
    }

    return obj;
  };
}

export const addDiscriminatorValues = transformOneOf(createTypenameToShapeId);
